import dueDateCalculator from '@/utils/due-date-calc';
import React from 'react';

function formatDecimalToTime(decimalTotalHours) {
	const hours = Math.floor(decimalTotalHours);
	const minutes = Number((decimalTotalHours - hours) * 60);

	return { timeStr: `${hours}:${minutes.toFixed(0).padStart(2, '0')}`, hours, minutes };
}

function getActivitiesReportDueDate(e) {
	if (!e?.encerramento?.ultimo_dia_em_campo || !e?.encerramento?.carga_horaria_realizada) return;

	const daysDeadline = 120;

	return dueDateCalculator(
		new Date(e.encerramento?.ultimo_dia_em_campo),
		daysDeadline,
		e?.prorrogacao_prazo_relatorio?.dias_de_prorrogacao || 0
	);
}

const DetailsBySituacao = {
	TERMO_EXPEDIDO: function (e) {
		const dateStr = (new Date(e?.expedido_em)).toLocaleDateString('pt-BR');
		return `em ${dateStr}`;
	},
	AGUARDANDO_VIGENCIA: function (e) {
		const start = new Date(e?.vigencia?.inicio);
		const remaining = Math.floor((start.getTime() - (new Date()).getTime()) / (1000 * 60 * 60 * 24));
		return `vigora em ${remaining} dias`;
	},
	VIGENTE: function (e) {
		const start = new Date(e?.vigencia?.inicio);
		const end = new Date(e?.vigencia?.fim);
		const elapsed = Math.floor(((new Date()).getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
		const remaining = Math.floor((end.getTime() - (new Date()).getTime()) / (1000 * 60 * 60 * 24));
		return `${elapsed} dias | restam ${remaining} dias`;
	},
	VIGENCIA_EXPIRADA: function (e) {
		const end = new Date(e?.vigencia?.fim);
		const elapsed = Math.floor(((new Date()).getTime() - end.getTime()) / (1000 * 60 * 60 * 24));
		return `há ${elapsed} dias`;
	},
	AGUARDANDO_RELATORIO: function (e) {
		if (!e?.encerramento?.ultimo_dia_em_campo || !e?.encerramento?.carga_horaria_realizada) return '';

		const dueDate = getActivitiesReportDueDate(e);
		const dueDateStr = dueDate?.toLocaleDateString('pt-BR');
		const { timeStr } = formatDecimalToTime(e?.encerramento?.carga_horaria_realizada);

		return `${timeStr}h | Prazo ${dueDateStr}`;
	},
	PRAZO_EXPIRADO: function (e) {
		if (!e?.encerramento?.ultimo_dia_em_campo || !e?.encerramento?.carga_horaria_realizada) return '';

		const dueDate = getActivitiesReportDueDate(e);
		if (!dueDate) return '';

		const dueDateStr = dueDate.toLocaleDateString('pt-BR');
		const { timeStr } = formatDecimalToTime(e?.encerramento?.carga_horaria_realizada);
		const elapsed = Math.floor(((new Date()).getTime() - dueDate.getTime()) / (1000 * 60 * 60 * 24));

		return `${timeStr}h | há ${elapsed} dias - ${dueDateStr} `;
	},
	INTEGRALIZADO: function (e) {
		const { timeStr } = formatDecimalToTime(e?.encerramento?.carga_horaria_realizada);
		const rel_date = (new Date(e?.consolidacao?.relatorio_recebido_em)).toLocaleDateString('pt-BR');
		const rel_aval = Number(e?.consolidacao?.nota_do_relatorio).toFixed(2);

		return `${timeStr}h | Relat. ${rel_aval} em ${rel_date}`;
	},
};

const StatusDetail = ({ estagio }) => {
	const info = DetailsBySituacao?.[estagio?.situacao] || ((_) => '');

	return (
		<span>
			{info(estagio) || ''}
		</span>
	);
};

StatusDetail.displayName = 'StatusDetail';

export default StatusDetail;
